function customSelectHandler(elementClass) {
	const customSelects = document.querySelectorAll(elementClass);
	if(!customSelects.length) {
		return;
	}

	customSelects.forEach(select => {
		const selectedDisplay = select.querySelector('.custom-select-selected');
		const options = select.querySelectorAll('.custom-select-option');
		const hiddenSelect = select.querySelector('.hidden-select');

		// Click event for the selected display
		selectedDisplay.addEventListener('click', function () {
			select.classList.toggle('active');

			// Close other selects
			customSelects.forEach(otherSelect => {
				if (otherSelect !== select) {
					otherSelect.classList.remove('active');
				}
			});
		});

		// Click event for options
		options.forEach(option => {
			option.addEventListener('click', function () {
				const value = this.getAttribute('data-value');
				const text = this.textContent;

				// Update the selected display
				select.querySelector('.selected-text').textContent = text;

				// Mark as selected in the options list
				options.forEach(opt => opt.classList.remove('selected'));
				this.classList.add('selected');

				// Update the hidden select for form submission
				hiddenSelect.value = value;

				// Close the dropdown
				select.classList.remove('active');

				// Trigger a change event on the hidden select
				const event = new Event('change', { bubbles: true });
				hiddenSelect.dispatchEvent(event);
			});
		});

		// Keyboard navigation
		selectedDisplay.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				select.classList.toggle('active');
			} else if (e.key === 'Escape') {
				select.classList.remove('active');
			} else if (e.key === 'ArrowDown' && select.classList.contains('active')) {
				e.preventDefault();
				options[0].focus();
			}
		});

		// Close when clicking outside
		document.addEventListener('click', function (e) {
			if (!select.contains(e.target)) {
				select.classList.remove('active');
			}
		});
	});
}

const customMultiSelectHandler = (customMultiSelect) => {
	const customMultiSelects = document.querySelectorAll(customMultiSelect);
	if (customMultiSelects.length === 0) {
		return;
	}

	customMultiSelects.forEach((customSelect) => {
		const selectButton = customSelect.querySelector(".select-button");
		const dropdown = customSelect.querySelector(".select-dropdown");
		const options = dropdown.querySelectorAll("li");
		const selectedValue = selectButton.querySelector(".selected-value");

		let focusedIndex = -1;

		const toggleDropdown = (expand = null) => {
			const isOpen =
				expand !== null ? expand : dropdown.classList.contains("hidden");
			dropdown.classList.toggle("hidden", !isOpen);
			selectButton.setAttribute("aria-expanded", isOpen);

			if (isOpen) {
				options.forEach((opt) => {
					opt.style.display = "block";
				});
				focusedIndex = [...options].findIndex((option) =>
					option.classList.contains("selected")
				);
				focusedIndex = focusedIndex === -1 ? 0 : focusedIndex;
				updateFocus();
			} else {
				focusedIndex = -1;
				selectButton.focus();
			}
		};

		const updateFocus = () => {
			options.forEach((option, index) => {
				if (option) {
					option.setAttribute("tabindex", index === focusedIndex ? "0" : "-1");
					if (index === focusedIndex) {
						option.focus();
					}
				}
			});
		};

		const handleOptionSelect = (option) => {
			options.forEach((opt) => opt.classList.remove("selected"));
			option.classList.add("selected");
			//selectedValue.textContent = option.textContent.trim(); // Update selected value
			var currentValue = selectedValue.innerHTML;
			if (currentValue.includes("Kérjük válasszon")) {
				selectedValue.innerHTML = "";
			}
			var currentValues = selectedValue.querySelectorAll("div");
			let insert = true;
			currentValues.forEach((element) => {
				if (element.querySelectorAll("span")[0].textContent.trim() === option.textContent.trim()) {
					insert = false;
					return;
				}
			});
			if (insert) {
				const hiddenInput = customSelect.querySelector("input[type=hidden]");
				var rs = [];
				if (hiddenInput.value === "") {
					rs.push(option.dataset.value);
					hiddenInput.value = JSON.stringify(rs);
				} else {
					rs = JSON.parse(hiddenInput.value.split(","));
					rs.push(option.dataset.value);
					hiddenInput.value = JSON.stringify(rs);
				}
				selectedValue.innerHTML = selectedValue.innerHTML + wrapHtml(option.innerHTML.trim(), option.dataset.value); // Add selected value (formatted)

			}

			if (option.dataset.value === "clear") {
				// Reset to the default value
				selectedValue.textContent = "Kérjük válasszon";
				hiddenInput.value = "";
				options.forEach((opt) => opt.classList.remove("selected"));
				return;
			}
		};

		options.forEach((option) => {
			option.addEventListener("click", () => {
				handleOptionSelect(option);
				toggleDropdown(false);
			});
		});

		selectButton.addEventListener("click", (e) => {
			if (e.target.classList.contains("selected-value")) {
				toggleDropdown();
			}
		});

		selectButton.addEventListener("keydown", (event) => {
			if (event.key === "ArrowDown") {
				event.preventDefault();
				toggleDropdown(true);
			} else if (event.key === "Escape") {
				toggleDropdown(false);
			}
		});

		dropdown.addEventListener("keydown", (event) => {
			if (event.key === "ArrowDown") {
				event.preventDefault();
				focusedIndex = (focusedIndex + 1) % options.length;
				updateFocus();
			} else if (event.key === "ArrowUp") {
				event.preventDefault();
				focusedIndex = (focusedIndex - 1 + options.length) % options.length;
				updateFocus();
			} else if (event.key === "Enter" || event.key === " ") {
				event.preventDefault();
				handleOptionSelect(options[focusedIndex]);
				toggleDropdown(false);
			} else if (event.key === "Escape") {
				toggleDropdown(false);
			} else {
				event.preventDefault();
				options.forEach((opt, index) => {
					if (opt.textContent.toLowerCase().startsWith(event.key.toLowerCase())) {
						focusedIndex = index;
						updateFocus();
						return;
					}
				});
			}
		});

		document.addEventListener("click", (event) => {
			const isOutsideClick = !customSelect.contains(event.target);
			if (isOutsideClick) {
				toggleDropdown(false);
			}
		});

	});
}

const wrapHtml = (text, value) => {
	return `<div class="d-flex align-items-center gap-2"><span style="cursor:auto;">${text}</span><span onclick="window.removeValue(this, '${value}')" class="pointer">&times;</span></div>`;
};

window.removeValue = (element, value) => {
	const customSelect = element.closest(".custom-multiselect");
	const text = element.previousSibling.textContent;

	selectedValue = element.parentElement.parentElement;
	const hiddenInput = customSelect.querySelector("input[type=hidden]");
	var currentValues = selectedValue.querySelectorAll("div");
	currentValues.forEach((element) => {
		if (text === element.querySelectorAll("span")[0].textContent.trim()) {
			selectedValue.removeChild(element);
		}
	});
	var rs = [];
	if (hiddenInput.value === "") {
		rs.push(text);
		hiddenInput.value = JSON.stringify(rs);
	} else {
		rs = JSON.parse(hiddenInput.value);
		let updated = [];
		rs.forEach((val) => {
			if (val !== value) {
				updated.push(val);
			}
		});
		hiddenInput.value = JSON.stringify(updated);
	}
	var currentValues = selectedValue.querySelectorAll("div");
	if (currentValues.length === 0) {
		selectedValue.innerHTML = "Kérjük válasszon";
		hiddenInput.value = "[]";
	}
};

document.addEventListener("DOMContentLoaded", () => {
	customSelectHandler('.custom-select-container');
	customMultiSelectHandler(".custom-multiselect");
});
